export function getData(response, successCode = 0) {
    const { data } = response
    if (data.code === successCode) {
        return data.data
    } else {
        throw data
    }
}

/**
 * 解析接口响应错误，返回用户更容易阅读的文字·
 * @param e
 * @return {string|*|string}
 */
export function parseError(e) {
    const handle = () => {
        if (!e) {
            return e
        }
        e = e.data || e
        if (e.tips || e.message || e.msg || e.errMsg) {
            return e.tips || e.message || e.msg || e.errMsg
        }
        try {
            return JSON.stringify(e)
        } catch (_) {
            return e
        }
    }

    const result = handle()
    try {
        const resultStr = result && result.toLowerCase()
        if (resultStr.indexOf('network') !== -1) {
            return '网络错误'
        }
        if (resultStr.indexOf('enotfound') !== -1) {
            return '网络错误，请重试'
        }
        return result
    } catch (e) {
        return result
    }
}



// WEBPACK FOOTER //
// ./src/api/util.js